import React from 'react';
import { Text } from '@react-pdf/renderer';
import { styles } from '../styles';
import { PageLayout } from '../PageLayout';
import { TablesComponent } from './TablesComponent';
import { ContractCharacteristics } from './ContractCharacteristics';
import { DeclarationsComponent } from '../DeclarationsComponent';
import { View } from '@react-pdf/renderer';

// Helper component for table cells
const Cell = ({ label, value, widthLabel, widthValue, isLast }) => (
    <>
        <View style={[styles.tableCol, { width: widthLabel + '%' }]}>
            <Text style={styles.tableCellLabel}>{label}</Text>
        </View>
        <View style={[styles.tableCol, { width: widthValue + '%' }]}>
            <Text style={styles.tableCellValue}>{value || ''}</Text>
        </View>
    </>
);

export const Page1 = ({ data, type }) => {
    const t = data.tenant;
    const lr = data.legal_rep || {};
    const g = data.guarantor || {};

    // Format dates if needed
    const formatDate = (dateString) => {
        if (!dateString) return '';
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString('es-MX');
        } catch (e) {
            return dateString;
        }
    };

    return (
        <PageLayout data={data}>

            {/* Tables */}
            <TablesComponent data={data} type={type} />

            <ContractCharacteristics data={data} type={type} />

            {/* Declarations */}
            <DeclarationsComponent type={type} data={data} />

            {/* Caracteristicar y firma PM */}
           {/*  <ContractCharacteristics data={data} type={type} /> */}

        </PageLayout>
    );
};
